import PropTypes from 'prop-types';
import React, { Children } from 'react';
import BaseComponent from 'apps/new-web/views/component';

export default class Hoverable extends BaseComponent {
  static get propTypes() {
    return {
      onHoverStart: PropTypes.func.isRequired,
      onHoverEnd: PropTypes.func.isRequired,
      hoverStartDelay: PropTypes.number,
      hoverEndDelay: PropTypes.number,
      children: PropTypes.element.isRequired
    };
  }

  constructor(props) {
    super(props);
    this.hovering = false;
  }

  hoverStart() {
    const { hoverStartDelay, menuKey, onHoverStart } = this.props;
    if (this.hoverEndTimeout) {
      clearTimeout(this.hoverEndTimeout);
      this.hoverEndTimeout = undefined;
    }

    if (this.hovering) return;

    this.hoverStartTimeout = setTimeout(() => {
      this.hovering = true;
      onHoverStart(menuKey);
    }, hoverStartDelay || 100);
  }

  hoverEnd() {
    const { hoverEndDelay, menuKey, onHoverEnd } = this.props;
    if (this.hoverStartTimeout) {
      clearTimeout(this.hoverStartTimeout);
      this.hoverStartTimeout = undefined;
    }

    if (!this.hovering) return;

    this.hoverEndTimeout = setTimeout(() => {
      this.hovering = false;
      onHoverEnd(menuKey);
    }, hoverEndDelay || 200);
  }

  render() {
    let childWithHoverEvents = React.cloneElement(
      this.props.children, {
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }
    );

    return Children.only(childWithHoverEvents);
  }
}
